import {
  POST_UPLOAD_STATE_DECLARATION_SUCCESS,
  POST_UPLOAD_STATE_DECLARATION_FAILURE,
} from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case POST_UPLOAD_STATE_DECLARATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case POST_UPLOAD_STATE_DECLARATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    default:
      return { ...state };
  }
};
